import { graphqlClient } from '@topconagriculture/graphql-client';
import { FETCH_ALERT_STATUS } from './index';
import { API_CLIENTS } from '../../config/constants';
export const getAlertsQuery = () => {
    return graphqlClient
        .getClient(API_CLIENTS.graphqlClient)
        .query({
        query: FETCH_ALERT_STATUS,
        fetchPolicy: 'network-only',
        variables: {},
    })
        .then((response) => {
        return response.data.alarmsSeverities;
    });
};
//# sourceMappingURL=alert.status.query.js.map